import { render, staticRenderFns } from "./blogimageuploader.component.vue?vue&type=template&id=8cff1040&scoped=true"
import script from "./blogimageuploader.component.vue?vue&type=script&lang=js"
export * from "./blogimageuploader.component.vue?vue&type=script&lang=js"
import style0 from "./blogimageuploader.component.vue?vue&type=style&index=0&id=8cff1040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cff1040",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
